
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_164zz_193",
  "result-state": "awsui_result-state_11huc_164zz_207",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_164zz_1",
  "root": "awsui_root_11huc_164zz_229",
  "with-result-button": "awsui_with-result-button_11huc_164zz_264",
  "result-text": "awsui_result-text_11huc_164zz_268",
  "result-container-error": "awsui_result-container-error_11huc_164zz_272",
  "result-container-success": "awsui_result-container-success_11huc_164zz_272",
  "result-button": "awsui_result-button_11huc_164zz_276",
  "word-wrap": "awsui_word-wrap_11huc_164zz_282",
  "label-flash": "awsui_label-flash_11huc_164zz_287",
  "label-key-value": "awsui_label-key-value_11huc_164zz_291",
  "flash": "awsui_flash_11huc_164zz_299",
  "progress-container": "awsui_progress-container_11huc_164zz_303",
  "percentage-container": "awsui_percentage-container_11huc_164zz_310",
  "percentage": "awsui_percentage_11huc_164zz_310",
  "complete": "awsui_complete_11huc_164zz_356",
  "progress-in-flash": "awsui_progress-in-flash_11huc_164zz_384",
  "additional-info": "awsui_additional-info_11huc_164zz_400"
};
  